module.exports = __webpack_public_path__ + "9893948c161fb5b1bf22e2043961a2ed.png";